import React, { useContext, useState } from "react";
import FloatingInput from "../FloatingInput";
import { CardElement } from "@stripe/react-stripe-js";
import LayoutContext from "../../../../contexts/LayoutContext";
import styled from "styled-components";

const Styles = styled.div`
    .cardElement {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 46px;
        border-radius: 5px;
    }
`;
const StripeInputs = () => {
    const [isCardNameTyping, setIsCardNameTyping] = useState(false);
    const [isCardTyping, setIsCardTyping] = useState(false);
    const { setPaymentPopupData, paymentPopupData, setStripeCardData } = useContext(LayoutContext);
    const customStyles = {
        base: {
            "padding": "16px",
            "color": "#fff",
            "fontWeight": "400",
            "fontSize": "14px",
            "fontSmoothing": "antialiased",
            ":-webkit-autofill": {
                color: "#fce883"
            },
            "::placeholder": {
                color: "#8C8C8C"
            }
        },
        invalid: {
            iconColor: "red",
            color: "red"
        }
    };

    return (
        <Styles className="w-100">
            <div className="frame-313373">
                <FloatingInput
                    label={"Name on card"}
                    onChange={e => {
                        setIsCardNameTyping(true);
                        setPaymentPopupData({
                            ...paymentPopupData,
                            nameOnCard: e.target.value
                        });
                    }}
                    isTyping={isCardNameTyping}
                    value={paymentPopupData?.nameOnCard}
                />
                <div className="w-100 cardElement">
                    <CardElement
                        id="card-element"
                        options={{
                            style: customStyles,
                            hidePostalCode: true,
                            disableLink: true
                        }}
                        onChange={e => {
                            setIsCardTyping(!e.empty);
                            setStripeCardData({
                                isCardNumber: true,
                                isCardExpData: true,
                                isCardCvv: true,
                                isComplete: e.complete
                            });
                        }}
                        className={`element ${isCardTyping ? "typing" : ""}`}
                    />
                </div>
            </div>
        </Styles>
    );
};

export default StripeInputs;
